module.exports = "/matchcenter-staging/assets/images/novasport_1.3dee16e73581d388f97139f39b92e09e.png";